<div>
	<span>
		{{getData()}}
	</span>
</div>
<div class="snackbar-close-align-right">
	<button type="submit" mat-button class="button-link-margin" (click)="dismiss()">
		<span translate>ok.value</span>
	</button>
</div>